// src/pages/produtos/combos/ApresentacaoConjuntoCad.js
import { useState } from 'react';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import { useConjunto } from '../../../contexts/produtos/combos/ConjuntoContext';
import { useApresentacaoConjunto } from '../../../contexts/produtos/combos/ApresentacaoConjuntoContext';
import Input from '../../../components/input/Input';
import ConjuntoSearch from './ConjuntoSearch';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';

const ApresentacaoConjuntoCad = ({ isOpen, onClose, apresentacaoId }) => {
  const [erros, setErros] = useState({});
  const [apresentacaoConjunto, setApresentacaoConjunto] = useState({
    apresentacaoId: '',
    conjuntoId:'',
    apresentacao: null,
  });

  const { conjuntos } = useConjunto();
  const { addApresentacaoConjunto } = useApresentacaoConjunto();

  const [showSearchConjuntoModal, setShowSearchConjuntoModal] = useState(false);

  const validateForm = () => {
    const novosErros = {};
    if (!apresentacaoConjunto.conjuntoId || isNaN(apresentacaoConjunto.conjuntoId)) {
      novosErros.conjuntoId = 'Código do conjunto é obrigatório';
    }
    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      ...apresentacaoConjunto,
      apresentacaoId: apresentacaoId,
      conjuntoId: apresentacaoConjunto.conjuntoId,      
    };
    delete payload.apresentacao;
    delete payload.conjuto;

    await addApresentacaoConjunto(payload);
    onClose();
  };

  const handleSelectConjunto = (conjuntoSel) => {

      setShowSearchConjuntoModal(false);

      if (conjuntoSel) {
        setApresentacaoConjunto({
          ...apresentacaoConjunto,
          conjuntoId: conjuntoSel.id,    
          conjuto:conjuntoSel,          
        });
        setErros((prev) => ({ ...prev, conjuntoId: '' }));
      }
  };

  const handleConjuntoExit = () => {
    const id = parseInt(apresentacaoConjunto.conjuntoId);
    if (!id || isNaN(id)) {
      setApresentacaoConjunto({ ...apresentacaoConjunto, conjuntoId: null });
      return;
    }

    const selected = conjuntos.find((a) => a.id === id);
    if (!selected) {
      setApresentacaoConjunto({ ...apresentacaoConjunto, conjuntoId: null });
      setErros((prev) => ({ ...prev, conjuntoId: 'Conjunto não encontrado!' }));
      return;
    }

    setApresentacaoConjunto({
      ...apresentacaoConjunto,
      apresentacaoId: selected.id,
      apresentacao: selected,
    });
    setErros((prev) => ({ ...prev, apresentacaoId: '' }));
  };

  if (!isOpen) return null;

  return (
    <ModalContainer show={isOpen} variant="cadastro" onHide={onClose}>
      <ModalHeader title="Apresentação do Conjunto" onHide={onClose} />

      <ModalBody>
        <div className="input-group">
          <Input
            label="Cód. Conjunto"
            value={apresentacaoConjunto.conjuntoId || ''}
            btnBuscar={() => setShowSearchConjuntoModal(true)}
            onChange={(e) => {
              setApresentacaoConjunto({ ...apresentacaoConjunto, conjuntoId: e.target.value });
              setErros((prev) => ({ ...prev, conjuntoId: '' }));
            }}
            onBlur={handleConjuntoExit}
            autoFocus
            msgErro={erros.conjuntoId}
          />
          <Input
            label="Descrição"
            value={apresentacaoConjunto.conjuto?.nome || ''}
            size={300}
            disabled
          />
        </div>
      </ModalBody>

      <ModalFooter className="modal-footer flex-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          Cancelar
        </button>
        <ModalActionButton className="btn btn-primary" onClick={handleSubmit} action="save">
          Gravar
        </ModalActionButton>
      </ModalFooter>

      <ConjuntoSearch
          show={showSearchConjuntoModal}
          onHide={() => setShowSearchConjuntoModal(false)}
          onSelectConjunto={handleSelectConjunto}
      />
    </ModalContainer>
  );
};

export default ApresentacaoConjuntoCad;